import { createWidgetWithErrorBoundary } from '@alfa-bank/site-util-create-widget/create-widget-with-error-boundary';

import { DividendBannerDesktop as View } from '../../components/dividend-banner/desktop';

import { DividendBannerContainer as Component } from './component';
import type { IDepsDesktop, TInvestEmitentsDetailCardDividendBanner } from './models';

export const InvestEmitentsDetailCardDividendBannerDesktop = createWidgetWithErrorBoundary<
    IDepsDesktop,
    TInvestEmitentsDetailCardDividendBanner
>({
    View,
})(Component);
